module.exports = __webpack_public_path__ + "img/emptyimg.fdc55a5e.png";